import type { AxiosRequestConfig } from 'axios';

export const getCacheKey = (url: string, params: AxiosRequestConfig | undefined) => {
  let cacheKey = url;

  if (params) {
    const tempParams = { ...params };
    const stringifiedParams = JSON.stringify(tempParams, Object.keys(tempParams).sort());
    cacheKey = `${cacheKey}${stringifiedParams}`;
  }

  return cacheKey;
};
